(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vhv-aanvraag"] && !Shopify.designMode) return;
  try {
    
(() => {
  const C = 50, R = 35, OPEN = [26, 19, 12, 6, 3], ROT = [0, 12, 24, 36, 46];
  const pt = (r, a) => [C + r * Math.cos(a * Math.PI / 180), C + r * Math.sin(a * Math.PI / 180)];
  function drawAp(root, n) {
    const ro = OPEN[n - 1], rot = ROT[n - 1];
    const V = [...Array(6)].map((_, i) => pt(ro, rot + 60 * i - 90));
    root.querySelector('[data-open]').setAttribute('points', V.map(p => p.map(x => x.toFixed(1)).join(',')).join(' '));
    let lines = '';
    V.forEach((v, i) => {
      const p = V[(i + 5) % 6]; let dx = v[0] - p[0], dy = v[1] - p[1]; const L = Math.hypot(dx, dy); dx /= L; dy /= L;
      const bx = v[0] - C, by = v[1] - C, b = bx * dx + by * dy, c = bx * bx + by * by - R * R, t = -b + Math.sqrt(b * b - c);
      lines += `<line x1="${v[0].toFixed(1)}" y1="${v[1].toFixed(1)}" x2="${(v[0] + dx * t).toFixed(1)}" y2="${(v[1] + dy * t).toFixed(1)}" stroke="rgb(255 255 255 / .38)" stroke-width="1.4"/>`;
    });
    root.querySelector('[data-blades]').innerHTML = lines;
  }
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const names = (root.dataset.names || '').split(',').map(s => s.trim());
    const nameEl = root.querySelector('[data-stepname]'), nrEl = root.querySelector('[data-stepnr]');
    const done = root.querySelector('[data-done]');
    if (done) {
      drawAp(root, 5); nameEl.textContent = names[4] || ''; nrEl.textContent = '';
      let n = ''; try { n = sessionStorage.getItem('vhvAqName') || ''; sessionStorage.removeItem('vhvAqName'); } catch (e) {}
      const h = done.querySelector('[data-thanks]'); if (n && h) h.textContent = h.dataset.thanks.replace('!', `, ${n}!`);
      return;
    }
    const form = root.querySelector('form'), steps = [...root.querySelectorAll('[data-step]')];
    const next = root.querySelector('[data-next]'), back = root.querySelector('[data-back]');
    if (!form || !steps.length) return;
    root.classList.add('aq-js');
    const total = steps.length; let step = root.querySelector('[data-has-errors]') ? total : 1;
    function show(n) {
      const dir = n < step; step = n;
      steps.forEach(s => { s.hidden = +s.dataset.step !== n; s.classList.toggle('aq-terug', dir); });
      nameEl.textContent = names[n - 1] || ''; nrEl.textContent = `(stap ${n} van ${total})`;
      back.hidden = n === 1;
      next.textContent = n === total ? next.dataset.send : next.dataset.label;
      next.type = n === total ? 'submit' : 'button';
      drawAp(root, n);
    }
    const status = root.querySelector('.aq-status');
    let lock = 0, sent = false;
    const busy = () => { const t = Date.now(); if (t - lock < 600) return true; lock = t; return false; };
    form.addEventListener('keydown', e => {
      if (e.key === 'Enter' && step < total && e.target.matches('input')) e.preventDefault();
    });
    const advance = () => {
      if (busy()) return;
      show(step + 1);
      if (status.getBoundingClientRect().top < 0) status.scrollIntoView({ block: 'start', behavior: 'smooth' });
    };
    next.addEventListener('click', e => { if (step < total) { e.preventDefault(); advance(); } });
    form.addEventListener('submit', e => {
      if (step < total) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      if (sent) { e.preventDefault(); return; }
      if (Date.now() - lock < 600) { e.preventDefault(); return; }
      const name = form.querySelector('[data-name]'), mail = form.querySelector('[data-mail]');
      const ok = name.value.trim() && /^\S+@\S+\.\S+$/.test(mail.value);
      root.querySelector('[data-err]').hidden = !!ok;
      if (!ok) { e.preventDefault(); return; }
      sent = true;
      try { sessionStorage.setItem('vhvAqName', name.value.trim().split(' ')[0]); } catch (err) {}
    });
    back.addEventListener('click', () => { if (!busy()) show(Math.max(1, step - 1)); });
    window.addEventListener('pageshow', e => { if (e.persisted) { sent = false; show(step); } });
    show(step);
  }
  const run = () => document.querySelectorAll('[data-aq]').forEach(init);
  run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vhv-frame-studio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vhv-studio')) {
    customElements.define('vhv-studio', class extends HTMLElement {
      connectedCallback() {
        try { this.items = JSON.parse(this.querySelector('[data-studio-data]').textContent || '[]'); } catch (e) { this.items = []; }
        this.items = this.items.filter(Boolean);
        if (!this.items.length) return;
        this.$ = (s) => this.querySelector('[data-slot="' + s + '"]');
        this.fmt = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.st = {};
        if (this.items.length > 1) {
          this.querySelector('[data-group="products"]').hidden = false;
          this.$('products').innerHTML = this.items.map((it, i) => `<button type="button" class="vhv-studio__thumb" data-i="${i}" aria-label="${it.title}"><img src="${it.thumb}" alt="" loading="lazy"></button>`).join('');
        }
        this.addEventListener('click', (e) => {
          const b = e.target.closest('[data-i],[data-k]'); if (!b) return;
          if (b.dataset.i !== undefined) this.pick(+b.dataset.i);
          else { this.st[b.dataset.k] = b.dataset.v; this.draw(); }
        });
        this.pick(0);
      }
      parse(l) { const m = (l || '').match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)\s*cm/i); return m ? [parseFloat(m[1]), parseFloat(m[2])] : null; }
      chips(slot, k, vals, label) { this.$(slot).innerHTML = vals.map((v) => `<button type="button" class="vhv-chip" data-k="${k}" data-v="${v.replace(/"/g, '&quot;')}">${label ? label(v) : v}</button>`).join(''); }
      fcol(f) { if (/black/i.test(f)) return '#141414'; if (/grey|gray/i.test(f)) return '#857a6e'; if (/white/i.test(f)) return '#f3f1ec'; return ''; }
      bcol(b) { if (/black/i.test(b)) return '#151515'; if (/freja|off/i.test(b)) return '#efe9dc'; if (/white/i.test(b)) return '#fbfbf9'; return ''; }
      pick(i) {
        this.p = this.items[i];
        this.querySelectorAll('[data-i]').forEach((b) => b.classList.toggle('is-active', +b.dataset.i === i));
        const o = this.p.options;
        this.si = o.findIndex((n) => /size/i.test(n)); this.fi = o.findIndex((n) => /frame/i.test(n)); this.bi = o.findIndex((n) => /passe|border/i.test(n));
        const uniq = (k) => (k < 0 ? [] : [...new Set(this.p.variants.map((v) => v.o[k]))]);
        const sizes = uniq(this.si).sort((a, b) => { const x = this.parse(a) || [0, 0], y = this.parse(b) || [0, 0]; return x[0] * x[1] - y[0] * y[1]; });
        const frames = uniq(this.fi), borders = uniq(this.bi);
        this.st = { size: sizes[Math.min(1, sizes.length - 1)], frame: frames.find((f) => /black/i.test(f)) || frames[0], border: borders.find((b) => /^white/i.test(b)) || borders[0] };
        this.chips('sizes', 'size', sizes, (s) => { const m = s.match(/\(([^)]+)\)/); const c = this.parse(s); return (m ? m[1] : '') + (c ? ' <span class="vhv-muted">' + c[0] + '×' + c[1] + '</span>' : ''); });
        this.chips('frames', 'frame', frames, (f) => `<span class="vhv-chip__sw" style="--f:${this.fcol(f) || 'transparent'}"></span>${f.replace(/ wood/i, '')}`);
        this.chips('borders', 'border', borders, (b) => `<span class="vhv-chip__sw" style="--f:${this.bcol(b) || 'transparent'}"></span>${b.replace(/\s*\(.*\)/, '')}`);
        this.querySelector('[data-group="frames"]').hidden = !frames.length;
        this.querySelector('[data-group="borders"]').hidden = !borders.length;
        this.$('img').src = this.p.img; this.$('img').alt = this.p.alt || this.p.title;
        this.draw();
      }
      draw() {
        const { size, frame, border } = this.st;
        ['size', 'frame', 'border'].forEach((k) => this.querySelectorAll('[data-k="' + k + '"]').forEach((b) => b.classList.toggle('is-active', b.dataset.v === this.st[k])));
        const cm = this.parse(size) || [3, 2];
        const framed = frame && !/no/i.test(frame); const matted = border && !/no/i.test(border);
        const big = Math.max(cm[0], cm[1]);
        const frameEl = this.$('frame'), mat = this.$('mat'), photo = this.$('photo');
        photo.style.aspectRatio = cm[0] + ' / ' + cm[1];
        let w = Math.min(84, 44 + big * 0.42); if (cm[0] < cm[1]) w = w * (cm[0] / cm[1]) * 1.04;
        frameEl.style.setProperty('--w', w + '%');
        frameEl.style.setProperty('--fc', framed ? this.fcol(frame) : 'transparent');
        frameEl.classList.toggle('is-framed', !!framed);
        mat.style.setProperty('--mc', matted ? this.bcol(border) : 'transparent');
        mat.classList.toggle('is-matted', !!matted);
        this.$('frame-note').textContent = framed ? (big > 70 ? '2 cm profile' : '1.5 cm profile') : '';
        this.$('tag').textContent = this.p.title + ' · ' + cm[0] + ' × ' + cm[1] + ' cm';
        const v = this.p.variants.find((x) => (this.si < 0 || x.o[this.si] === size) && (this.fi < 0 || x.o[this.fi] === frame) && (this.bi < 0 || x.o[this.bi] === border));
        if (v) {
          this.$('variant').value = v.id;
          this.$('price').textContent = this.fmt.format(v.p / 100);
          this.$('vt').textContent = v.o.join(' · ');
          this.$('add').disabled = !v.a;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vhv-funnel"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.vhv-funnel').forEach((root) => {
    const form = root.querySelector('form');
    if (!form || !form.querySelector('[data-step]')) return;
    const steps = [...form.querySelectorAll('[data-step]')];
    const bars = [...root.querySelectorAll('[data-bar]')];
    const hint = form.querySelector('[data-hint]');
    const img = root.querySelector('.vhv-funnel__aside-img');
    const cap = root.querySelector('.vhv-funnel__cap');
    let i = 0;
    root.classList.add('is-js');
    const show = (n, focus) => {
      i = Math.max(0, Math.min(steps.length - 1, n));
      steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
      bars.forEach((b, k) => b.classList.toggle('is-on', k <= i));
      if (focus) { const f = steps[i].querySelector('input:not([type=hidden]),select,textarea'); if (f) f.focus({ preventScroll: true }); steps[i].scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
    };
    form.addEventListener('click', (e) => {
      if (e.target.closest('[data-back]')) { show(i - 1, true); return; }
      if (!e.target.closest('[data-next]')) return;
      if (i === 0 && !steps[0].querySelector('input[type=checkbox]:checked')) { if (hint) hint.hidden = false; return; }
      if (hint) hint.hidden = true;
      show(i + 1, true);
    });
    const peek = (opt) => {
      if (!img || !opt || !opt.dataset.img) return;
      if (img.dataset.cur === opt.dataset.img) return;
      img.dataset.cur = opt.dataset.img;
      img.removeAttribute('srcset');
      img.style.opacity = 0;
      const pre = new Image();
      pre.onload = () => { img.src = opt.dataset.img; img.style.opacity = 1; };
      pre.src = opt.dataset.img;
      if (cap) cap.textContent = opt.dataset.cap || '';
    };
    const opts = [...root.querySelectorAll('.vhv-funnel__opt')];
    const deck = root.querySelector('[data-slides]');
    if (deck && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const withImg = opts.filter((o) => o.dataset.img);
      let k = 0;
      if (withImg.length > 1) setInterval(() => { if (document.hidden) return; k = (k + 1) % withImg.length; peek(withImg[k]); }, 4500);
    }
    opts.forEach((opt) => {
      opt.addEventListener('mouseenter', () => peek(opt));
      opt.addEventListener('change', () => peek(opt));
    });
    show(0, false);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vhv-print-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vhv-builder')) {
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    const wait = (ms) => new Promise((r) => setTimeout(r, ms));
    const timed = (p, ms) => Promise.race([p, wait(ms)]);
    const idle = (f) => (window.requestIdleCallback ? window.requestIdleCallback(f, { timeout: 1500 }) : setTimeout(f, 200));
    const NONE = /^(no|none|zonder|geen)\b/i;
    const KEYS = ['size', 'frame', 'border'];

    customElements.define('vhv-builder', class extends HTMLElement {
      connectedCallback() {
        if (this._init) { if (this.ro && this.stage) this.ro.observe(this.stage); return; }
        this._init = true;
        try { this.items = JSON.parse(this.querySelector('[data-pb-data]').textContent || '[]').filter(Boolean); } catch (e) { this.items = []; }
        if (!this.items.length) return;
        this.$ = (s) => this.querySelector('[data-slot="' + s + '"]');
        const nf = (d) => new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'EUR', minimumFractionDigits: d, maximumFractionDigits: d });
        const f0 = nf(0), f2 = nf(2);
        this.fmt = { format: (x) => (Math.round(x * 100) % 100 === 0 ? f0 : f2).format(x) };
        this.stage = this.$('stage');
        this.zoom = this.$('zoom');
        this.imgs = [...this.querySelectorAll('[data-img]')];
        this.front = 0;
        this.mode = 'studio';
        this.tab = 'all';
        this.st = {};
        this.cache = {};
        this.pre = {};
        this.tok = 0;
        this.cur = null;
        this.want = null;
        this.loading = false;
        this.touched = false;
        this.rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
        this.addLabel = this.$('add').textContent.trim();
        try { this.t = JSON.parse(this.querySelector('[data-pb-i18n]').textContent).split('|'); } catch (e) { this.t = []; }
        this.imgs.forEach((im) => {
          im.addEventListener('error', () => { if (im.getAttribute('src')) im.classList.add('is-broken'); });
          im.addEventListener('load', () => {
            // A print without a size previews at the photo's own aspect once its real shape is known.
            const it = this.items[this.cur];
            if (!it || it.ar || !im.naturalWidth || im !== this.imgs[this.front]) return;
            it.ar = im.naturalWidth / im.naturalHeight;
            if (!this.cm) this.layout();
          });
        });
        this.renderStrip();
        this.setupTabs();
        this.addEventListener('click', (e) => this.onClick(e));
        this.stage.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
        });
        let x0 = null, y0 = null;
        this.stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        this.stage.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.step(dx < 0 ? 1 : -1);
          x0 = y0 = null;
        });
        const strip = this.$('strip');
        if (strip) {
          const pf = (e) => { const b = e.target && e.target.closest && e.target.closest('[data-i]'); if (b) this.prefetch(+b.dataset.i); };
          strip.addEventListener('pointerover', pf);
          strip.addEventListener('focusin', pf);
          strip.addEventListener('touchstart', pf, { passive: true });
        }
        this.zoom.addEventListener('transitionend', (e) => { if (e.target === this.zoom && e.propertyName === 'transform') this.zoom.classList.remove('is-zooming'); });
        this.$('form').addEventListener('submit', (e) => this.add(e));
        this.ro = new ResizeObserver((en) => {
          const r = en[en.length - 1].contentRect;
          if (r.width === this.W && r.height === this.H) return;
          const had = this.W != null;
          this.W = r.width; this.H = r.height;
          if (had && this.drawn) {
            this.stage.classList.add('is-instant');
            clearTimeout(this.rzT);
            this.rzT = setTimeout(() => this.stage.classList.remove('is-instant'), 150);
          }
          this.layout();
        });
        this.ro.observe(this.stage);
        const h = this.fromHash();
        this.pick(h ? h.i : 0, h);
        if (h) {
          const sy = window.scrollY;
          setTimeout(() => { if (Math.abs(window.scrollY - sy) > 4) return; this.scrollIntoView({ behavior: this.beh(), block: 'start' }); }, 300);
        }
      }
      disconnectedCallback() { this.ro && this.ro.disconnect(); }
      beh() { return this.rm && this.rm.matches ? 'auto' : 'smooth'; }
      visible() { return this.items.map((it, i) => i).filter((i) => this.tab === 'all' || (this.tab === 'bw') === !!this.items[i].bw); }
      renderStrip() {
        const strip = this.$('strip'); if (!strip) return;
        strip.innerHTML = this.items.map((it, i) => `<button type="button" class="vhv-pb__item" data-i="${i}" aria-pressed="false"><span class="vhv-pb__thumb"><img src="${esc(it.thumb)}" alt="" loading="lazy" decoding="async"></span><span class="vhv-pb__name">${esc(it.title)}</span>${it.from ? `<span class="vhv-pb__from">from ${esc(it.from)}</span>` : ''}</button>`).join('');
      }
      setupTabs() {
        const tabs = this.$('tabs'); if (!tabs) return;
        const bw = this.items.filter((x) => x.bw).length;
        // With only one kind of print the other tab would be empty and "All" would equal the remaining one.
        if (!bw || bw === this.items.length) tabs.hidden = true;
      }
      onClick(e) {
        const t = e.target;
        let b;
        if (t.closest('[data-retry]')) return this.pick(this.want);
        if ((b = t.closest('[data-i]'))) return this.pick(+b.dataset.i);
        if ((b = t.closest('[data-tab]'))) {
          this.tab = b.dataset.tab;
          this.querySelectorAll('[data-tab]').forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          const v = this.visible();
          this.querySelectorAll('.vhv-pb__item').forEach((x) => { x.hidden = !v.includes(+x.dataset.i); });
          if (!v.includes(this.want)) this.pick(v[0]);
          return;
        }
        if ((b = t.closest('[data-mode]'))) {
          const m = b.dataset.mode;
          if (m === this.mode) return;
          const z = m === 'detail' || this.mode === 'detail';
          this.mode = m;
          this.querySelectorAll('[data-mode]').forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          this.stage.classList.remove('is-studio', 'is-room', 'is-detail');
          this.stage.classList.add('is-' + m);
          if (z) {
            this.zoom.classList.add('is-zooming');
            clearTimeout(this.zT);
            this.zT = setTimeout(() => this.zoom.classList.remove('is-zooming'), 1000);
          }
          if (m === 'detail') this.upgrade();
          return this.layout();
        }
        if ((b = t.closest('[data-wall]'))) {
          this.querySelectorAll('[data-wall]').forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          this.stage.style.setProperty('--wall', b.dataset.wall);
          this.stage.classList.toggle('is-dark-wall', b.dataset.wall === '#3a3936');
          return;
        }
        if ((b = t.closest('[data-step]'))) return this.step(+b.dataset.step);
        if ((b = t.closest('[data-k]'))) return this.choose(b.dataset.k, b.dataset.v);
        if (t.closest('[data-slot="share"]')) return this.share();
      }
      tx(i, fb) { return this.t && this.t[i] ? this.t[i] : fb; }
      step(d) {
        const v = this.visible(); if (v.length < 2) return;
        const at = v.indexOf(this.want);
        this.pick(v[(at + d + v.length) % v.length]);
      }
      load(it) {
        if (it.variants) return Promise.resolve(it);
        if (!this.cache[it.handle]) {
          this.cache[it.handle] = fetch(it.url + '.js', { headers: { Accept: 'application/json' } })
            .then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
            .then((d) => {
              it.options = (d.options || []).map((o) => (typeof o === 'string' ? o : o.name));
              it.variants = (d.variants || []).map((v) => ({ id: v.id, o: v.options, p: v.price, a: v.available }));
              return it;
            })
            .catch((err) => { delete this.cache[it.handle]; throw err; });
        }
        return this.cache[it.handle];
      }
      preload(src) {
        if (!src) return Promise.resolve(null);
        if (!this.pre[src]) {
          const im = new Image();
          im.decoding = 'async';
          im.src = src;
          const p = im.decode ? im.decode() : new Promise((res, rej) => { im.onload = res; im.onerror = rej; });
          this.pre[src] = p.then(() => im, () => { delete this.pre[src]; return null; });
        }
        return this.pre[src];
      }
      src(it) {
        const W = this.W || this.stage.clientWidth || 0;
        return it.img_s && this.mode !== 'detail' && W * (window.devicePixelRatio || 1) <= 800 ? it.img_s : it.img;
      }
      prefetch(i) {
        const it = this.items[i];
        if (!it || i === this.cur) return;
        this.load(it).catch(() => {});
        this.preload(this.src(it));
      }
      upgrade() {
        const it = this.items[this.cur], f = this.imgs[this.front];
        if (!it || !it.img_s || f.dataset.u !== it.img_s) return;
        this.preload(it.img).then((im) => { if (im && f.dataset.u === it.img_s) { f.src = it.img; f.dataset.u = it.img; } });
      }
      busy(on) {
        clearTimeout(this.busyT);
        const v = on ? 'true' : 'false';
        this.stage.setAttribute('aria-busy', v);
        this.$('form').setAttribute('aria-busy', v);
        if (on) {
          this.$('add').disabled = true;
          this.busyT = setTimeout(() => this.stage.classList.add('is-busy'), 150);
        } else {
          this.stage.classList.remove('is-busy');
        }
      }
      say(text, html) { const m = this.$('msg'); if (html) m.innerHTML = text; else m.textContent = text; }
      hush(im) {
        // Drop an image to transparent at once (cancelling any pending fade) before giving it a new source.
        im.style.transition = 'none';
        im.classList.remove('is-on');
        void im.offsetWidth;
        im.style.transition = '';
      }
      mark(i) {
        this.querySelectorAll('.vhv-pb__item').forEach((b) => { const on = +b.dataset.i === i; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        const strip = this.$('strip'), act = strip && strip.querySelector('.vhv-pb__item.is-active');
        if (!act) return;
        const behavior = this.cur == null ? 'auto' : this.beh();
        const r = strip.getBoundingClientRect();
        if (r.top >= 0 && r.bottom <= window.innerHeight) {
          act.scrollIntoView({ inline: 'center', block: 'nearest', behavior });
        } else {
          // Strip is off screen: centre it without moving the page.
          const a = act.getBoundingClientRect();
          strip.scrollBy({ left: a.left + a.width / 2 - (r.left + r.width / 2), behavior });
        }
      }
      async pick(i, preset) {
        const it = i == null ? null : this.items[i];
        if (!it) return;
        if (!preset && i === this.want && (this.loading || i === this.cur)) return;
        const tok = ++this.tok;
        this.want = i;
        this.mark(i);
        this.say('');
        if (i === this.cur && !preset) {
          this.loading = false;
          this.busy(false);
          this.draw();
          return;
        }
        this.loading = true;
        this.busy(true);
        const first = this.cur == null;
        const src = this.src(it);
        try {
          if (first) await this.load(it);
          else await Promise.all([this.load(it), timed(this.preload(src), 2500)]);
        } catch (e) {
          if (tok !== this.tok) return;
          this.loading = false;
          this.busy(false);
          this.say(esc(this.tx(0, 'Could not load this print.')) + ' <button type="button" class="vhv-pb__retry" data-retry>' + esc(this.tx(1, 'Try again')) + '</button>', true);
          this.$('add').disabled = true;
          return;
        }
        if (tok !== this.tok) return;
        const back = this.imgs[1 - this.front];
        this.hush(back);
        back.classList.remove('is-broken');
        back.dataset.u = src;
        back.src = src;
        if (!first) {
          if (back.decode) await timed(back.decode().catch(() => {}), 400);
          if (tok !== this.tok) return;
        }
        if (back.naturalWidth) it.ar = back.naturalWidth / back.naturalHeight;
        this.loading = false;
        this.cur = i;
        this.build(it, preset);
        this.$('title').textContent = it.title;
        const show = () => {
          if (tok !== this.tok || this.imgs[1 - this.front] !== back) return;
          const front = this.imgs[this.front];
          back.alt = it.alt || it.title;
          back.removeAttribute('aria-hidden');
          back.classList.add('is-on');
          front.classList.remove('is-on');
          front.alt = '';
          front.setAttribute('aria-hidden', 'true');
          this.front = 1 - this.front;
          if (back.naturalWidth && !it.ar) { it.ar = back.naturalWidth / back.naturalHeight; if (!this.cm) this.layout(); }
        };
        if (!this.drawn) {
          this.drawn = true;
          this.stage.classList.add('is-instant');
          this.draw();
          void this.stage.offsetWidth;
          requestAnimationFrame(() => this.stage.classList.remove('is-instant'));
        } else {
          this.draw();
        }
        this.busy(false);
        this.$('add').disabled = !this.canAdd();
        if (first && back.decode) back.decode().then(show, show); else show();
        idle(() => {
          if (tok !== this.tok) return;
          const v = this.visible(), at = v.indexOf(i), n = v.length;
          if (at < 0 || n < 2) return;
          this.prefetch(v[(at + 1) % n]);
          this.prefetch(v[(at - 1 + n) % n]);
        });
      }
      ki(k) { return k === 'size' ? this.si : k === 'frame' ? this.fi : this.bi; }
      stOf(x) { const o = {}; KEYS.forEach((k) => { const j = this.ki(k); o[k] = j < 0 ? undefined : x.o[j]; }); return o; }
      build(it, preset) {
        const o = it.options || [];
        this.si = o.findIndex((n) => /size|formaat/i.test(n)); this.fi = o.findIndex((n) => /frame|lijst/i.test(n)); this.bi = o.findIndex((n) => /passe|border/i.test(n));
        const uniq = (k) => (k < 0 ? [] : [...new Set(it.variants.map((v) => v.o[k]))]);
        this.sizes = uniq(this.si).sort((a, b) => { const x = this.parse(a) || [0, 0], y = this.parse(b) || [0, 0]; return x[0] * x[1] - y[0] * y[1]; });
        this.frames = uniq(this.fi); this.borders = uniq(this.bi);
        const keep = (list, cur, fb) => (cur && list.includes(cur) ? cur : fb);
        this.st = {
          size: preset && this.sizes[preset.s] ? this.sizes[preset.s] : keep(this.sizes, this.st.size, this.sizes[Math.min(2, this.sizes.length - 1)]),
          frame: preset && this.frames[preset.f] ? this.frames[preset.f] : keep(this.frames, this.st.frame, this.frames.find((f) => /black|zwart/i.test(f)) || this.frames[0]),
          border: preset && this.borders[preset.b] ? this.borders[preset.b] : keep(this.borders, this.st.border, this.borders.find((b) => /^(white|wit)\b/i.test(b)) || this.borders[0]),
        };
        if (!this.find(this.st) && !this.resolve('size', this.st.size)) {
          const v = it.variants.find((x) => x.a) || it.variants[0];
          if (v) this.st = this.stOf(v);
        }
        const so = '<span class="vhv-visually-hidden" data-so></span>';
        const mk = (slot, k, vals, label) => { this.$(slot).innerHTML = vals.map((v) => `<button type="button" class="vhv-chip" aria-pressed="false" data-k="${k}" data-v="${esc(v)}">${label(v)}${so}</button>`).join(''); };
        mk('sizes', 'size', this.sizes, (s) => { const m = s.match(/\(([^)]+)\)/); const c = this.parse(s); return (m ? '<b>' + esc(m[1]) + '</b> ' : '') + (c ? c[0] + '×' + c[1] : esc(s)); });
        mk('frames', 'frame', this.frames, (f) => `<span class="vhv-chip__sw" style="--f:${this.fcol(f)}"></span>${esc(f.replace(/\s*(wood|hout)\b/i, ''))}`);
        mk('borders', 'border', this.borders, (b) => `<span class="vhv-chip__sw" style="--f:${this.bcol(b)}"></span>${esc(b.replace(/\s*\(.*\)/, ''))}`);
        this.querySelector('[data-group="sizes"]').hidden = !this.sizes.length;
        this.querySelector('[data-group="frames"]').hidden = !this.frames.length;
        this.querySelector('[data-group="borders"]').hidden = !this.borders.length;
      }
      parse(l) { const m = (l || '').match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm/i); return m ? [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))] : null; }
      nominal(it) {
        // No size option (or no size in the label): preview at a nominal size with the photo's own aspect.
        const ar = it && it.ar > 0 ? it.ar : 1.5;
        return ar >= 1 ? [45, Math.round(450 / ar) / 10] : [Math.round(450 * ar) / 10, 45];
      }
      fcol(f) {
        if (!f || NONE.test(f)) return 'transparent';
        if (/black|zwart/i.test(f)) return '#141414';
        if (/grey|gray|grijs/i.test(f)) return '#857a6e';
        if (/white|wit\b/i.test(f)) return '#f3f1ec';
        if (/walnut/i.test(f)) return '#5c4030';
        if (/oak/i.test(f)) return '#b48a5c';
        if (/natural|wood|birch|ash/i.test(f)) return '#c9a77c';
        return '#8c867e';
      }
      bcol(b) {
        if (!b || NONE.test(b)) return 'transparent';
        if (/black|zwart/i.test(b)) return '#151515';
        if (/freja|off|gebroken/i.test(b)) return '#efe9dc';
        if (/white|wit\b/i.test(b)) return '#fbfbf9';
        return '#f1ede5';
      }
      find(st) {
        const it = this.items[this.cur];
        if (!it || !it.variants) return undefined;
        return it.variants.find((x) => (this.si < 0 || x.o[this.si] === st.size) && (this.fi < 0 || x.o[this.fi] === st.frame) && (this.bi < 0 || x.o[this.bi] === st.border));
      }
      resolve(k, v) {
        // Keep the chosen value; pick the other options from the best variant that has it (in stock first, then closest).
        const it = this.items[this.cur], j = this.ki(k);
        if (!it || !it.variants) return false;
        const cands = it.variants.filter((x) => j < 0 || x.o[j] === v);
        if (!cands.length) return false;
        const score = (x) => (x.a ? 10 : 0) + KEYS.filter((kk) => kk !== k && this.ki(kk) >= 0 && x.o[this.ki(kk)] === this.st[kk]).length;
        let best = cands[0];
        cands.forEach((x) => { if (score(x) > score(best)) best = x; });
        this.st = this.stOf(best);
        return true;
      }
      choose(k, v) {
        if (this.cur == null || this.loading || this.want !== this.cur) return;
        if (v === this.st[k]) return;
        const next = Object.assign({}, this.st, { [k]: v });
        if (this.find(next)) this.st = next;
        else if (!this.resolve(k, v)) this.st = next;
        this.touched = true;
        this.draw();
      }
      canAdd() {
        if (this.cur == null || this.loading || this.want !== this.cur) return false;
        const b = this.find(this.st);
        return !!(b && b.a);
      }
      draw() {
        const it = this.items[this.cur];
        if (!it) return;
        const base = this.find(this.st);
        this.querySelectorAll('[data-k]').forEach((b) => {
          const k = b.dataset.k, v = b.dataset.v, on = v === this.st[k];
          const alt = on ? base : this.find(Object.assign({}, this.st, { [k]: v }));
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.classList.toggle('is-missing', !alt);
          b.classList.toggle('is-soldout', !!alt && !alt.a);
          const so = b.querySelector('[data-so]');
          if (so) so.textContent = alt && !alt.a ? ', ' + this.tx(2, 'sold out') : '';
          let txt = '';
          if (!on) {
            if (!alt) txt = this.tx(3, 'Not offered');
            else if (base && alt.id !== base.id && alt.p !== base.p) txt = (alt.p > base.p ? '+' : '-') + this.fmt.format(Math.abs(alt.p - base.p) / 100);
          }
          let d = b.querySelector('.vhv-pb__d');
          if (txt) {
            if (!d) { d = document.createElement('span'); d.className = 'vhv-pb__d'; b.insertBefore(d, so); }
            d.textContent = txt;
          } else if (d) {
            d.remove();
          }
        });
        const cm = this.parse(this.st.size);
        this.cm = cm;
        this.framed = !!this.st.frame && !NONE.test(this.st.frame);
        this.matted = !!this.st.border && !NONE.test(this.st.border);
        const sz = cm ? cm[0] + ' × ' + cm[1] + ' cm' : '';
        this.$('dims').textContent = sz;
        this.$('frame-note').textContent = this.framed ? (cm && Math.max(cm[0], cm[1]) > 70 ? this.tx(4, '2 cm profile') : this.tx(5, '1.5 cm profile')) : '';
        this.$('tag').textContent = it.title + (sz ? ', ' + sz : '');
        const bits = [sz ? sz + ' ' + this.tx(6, 'photo print') : this.tx(7, 'Photo print')];
        if (this.framed) {
          const fl = this.st.frame.toLowerCase();
          bits.push(this.tx(8, '{v} frame').replace('{v}', fl.replace(/\s*frame$/, '').replace(/\bwood$/, 'wooden')));
        } else {
          bits.push(this.tx(9, 'no frame'));
        }
        if (this.matted) bits.push(this.tx(10, '{v} passe-partout').replace('{v}', this.st.border.replace(/\s*\(.*\)/, '').toLowerCase()));
        this.$('summary').textContent = bits.join(', ');
        this.$('done').hidden = true;
        const add = this.$('add');
        if (base) {
          this.$('variant').value = base.id;
          this.$('price').textContent = this.fmt.format(base.p / 100);
          this.$('link').href = it.url + '?variant=' + base.id;
          this.say('');
        } else {
          this.$('variant').value = '';
          this.$('price').textContent = '';
          this.$('link').href = it.url;
          this.say(this.tx(11, 'Not available in this combination'));
        }
        add.disabled = !this.canAdd();
        add.textContent = base && !base.a ? this.tx(12, 'Sold out') : this.addLabel;
        if (this.touched) this.toHash();
        this.layout();
      }
      layout() {
        const it = this.items[this.cur];
        if (!it || !this.st) return;
        let W = this.W, H = this.H;
        if (!W || !H) { const r = this.stage.getBoundingClientRect(); W = r.width; H = r.height; }
        if (!W || !H) return;
        const frame = this.$('frame'), mat = this.$('mat'), photo = this.$('photo'), sofa = this.stage.querySelector('.vhv-pb__sofa');
        const [w, h] = this.cm || this.nominal(it);
        const big = Math.max(w, h);
        const prof = big > 70 ? 2 : 1.5;
        const room = this.mode === 'room';
        const floor = H * 0.1;
        let pxcm;
        if (room) {
          // True scale against a 3 m wide wall, but never taller than the space above the sofa.
          pxcm = Math.min(W / 300, (H - floor) / (82 + 22 + h + (this.framed ? prof * 2 : 0) + 8));
        } else {
          pxcm = (Math.min(W * 0.74, H * 0.8) * (0.6 + Math.min(big, 100) / 250)) / big;
        }
        const fw = this.framed ? Math.max(3, prof * pxcm * (room ? 1 : 1.4)) : 0;
        const mw = this.matted ? Math.max(4, Math.min(w, h) * 0.1 * pxcm) : 0;
        const pw = Math.max(4, w * pxcm - mw * 2), ph = Math.max(4, h * pxcm - mw * 2);
        const ow = pw + mw * 2 + fw * 2, oh = ph + mw * 2 + fw * 2;
        const x = (W - ow) / 2;
        const y = room ? H - floor - 104 * pxcm - oh : (H - oh) / 2;
        photo.style.width = pw + 'px';
        photo.style.height = ph + 'px';
        mat.style.padding = mw + 'px';
        mat.style.backgroundColor = this.matted ? this.bcol(this.st.border) : 'transparent';
        frame.style.borderWidth = fw + 'px';
        frame.style.borderColor = this.framed ? this.fcol(this.st.frame) : 'transparent';
        frame.style.setProperty('--fw', fw + 'px');
        frame.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
        frame.classList.toggle('is-framed', this.framed);
        if (sofa) { sofa.style.width = 210 * pxcm + 'px'; sofa.style.height = 82 * pxcm + 'px'; }
        if (this.mode === 'detail') {
          const s = 2.6, cx = x + fw + mw * 0.6, cy = y + fw + mw * 0.6;
          this.zoom.style.transform = 'translate3d(' + -cx * (s - 1) + 'px, ' + -cy * (s - 1) + 'px, 0) scale(' + s + ')';
        } else {
          this.zoom.style.transform = 'translate3d(0px, 0px, 0) scale(1)';
        }
      }
      toHash() {
        const it = this.items[this.cur];
        if (!it) return;
        const h = '#print=' + it.handle + '/' + this.sizes.indexOf(this.st.size) + '/' + this.frames.indexOf(this.st.frame) + '/' + this.borders.indexOf(this.st.border);
        try { history.replaceState(null, '', location.pathname + location.search + h); } catch (e) {}
      }
      fromHash() {
        const m = location.hash.match(/^#print=([^/]+)\/(-?\d+)\/(-?\d+)\/(-?\d+)/);
        if (!m) return null;
        const i = this.items.findIndex((it) => it.handle === m[1]);
        return i < 0 ? null : { i, s: +m[2], f: +m[3], b: +m[4] };
      }
      share() {
        this.toHash();
        const btn = this.$('share'), url = location.href;
        const done = () => { const t = btn.textContent; btn.textContent = this.tx(13, 'Link copied'); setTimeout(() => { btn.textContent = t; }, 1800); };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
      }
      async add(e) {
        if (!window.fetch) return;
        e.preventDefault();
        if (!this.canAdd()) return;
        const btn = this.$('add'), form = this.$('form');
        const fail = this.tx(14, 'Could not add this print to your cart. Please try again.');
        btn.disabled = true;
        form.setAttribute('aria-busy', 'true');
        this.$('done').hidden = true;
        this.say('');
        try {
          let r;
          try {
            r = await fetch(this.dataset.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +this.$('variant').value, quantity: 1 }] }) });
          } catch (err) {
            // Network failure: let the browser post the form the classic way.
            if (err instanceof TypeError) { form.submit(); return; }
            throw err;
          }
          if (r.ok) {
            this.$('done').hidden = false;
            fetch(this.dataset.cart + '.js').then((x) => x.json()).then((c) => {
              document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: c, sourceId: this.id, data: { itemCount: c.item_count, source: 'vhv-builder' } } }));
            }).catch(() => {});
          } else {
            let j = null;
            try { j = await r.json(); } catch (x) {}
            const d = j && (typeof j.description === 'string' ? j.description : typeof j.message === 'string' ? j.message : '');
            this.say(d || fail);
          }
        } catch (err) {
          this.say(fail);
        } finally {
          form.setAttribute('aria-busy', 'false');
          btn.disabled = !this.canAdd();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vhv-print-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vhv-finder')) {
    customElements.define('vhv-finder', class extends HTMLElement {
      connectedCallback() {
        try { this.items = JSON.parse(this.querySelector('[data-finder-data]').textContent || '[]'); } catch (e) { this.items = []; }
        this.fmt = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.a = {};
        this.steps = [...this.querySelectorAll('[data-step]')];
        this.dots = [...this.querySelectorAll('.vhv-finder__progress li')];
        this.addEventListener('click', (e) => {
          const o = e.target.closest('.vhv-finder__opt');
          if (o) { this.a[o.dataset.k] = o.dataset.v; this.go(+o.closest('[data-step]').dataset.step + 1); }
          if (e.target.closest('[data-restart]')) { this.a = {}; this.go(0); }
        });
      }
      go(n) {
        this.steps.forEach((s, i) => s.classList.toggle('is-current', i === n));
        this.dots.forEach((d, i) => d.classList.toggle('is-on', i <= Math.min(n, 2)));
        if (n === 3) this.result();
        const r = this.getBoundingClientRect();
        if (r.top < 0) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      parse(l) { const m = l.match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)\s*cm/i); return m ? Math.max(parseFloat(m[1]), parseFloat(m[2])) : null; }
      result() {
        const { mood, tone, wall } = this.a; const target = +wall || 60;
        const scored = this.items.map((it) => {
          let s = 0;
          if (it.moods.map((m) => m.trim()).includes(mood)) s += 3;
          if (tone === 'any' || tone === it.tone) s += 2;
          return { it, s: s + Math.random() * 0.5 };
        }).sort((x, y) => y.s - x.s).slice(0, 3);
        const html = scored.map(({ it }) => {
          const p = it.p; const si = p.options.findIndex((n) => /size/i.test(n)); const fi = p.options.findIndex((n) => /frame/i.test(n));
          const pool = p.variants.filter((v) => fi < 0 || /no/i.test(v.o[fi]));
          let best = pool[0];
          pool.forEach((v) => { const cm = this.parse(v.o[si] || ''); const bcm = this.parse(best.o[si] || ''); if (cm && (!bcm || Math.abs(cm - target) < Math.abs(bcm - target))) best = v; });
          const size = best ? (best.o[si] || '') : '';
          const short = (size.match(/\(([^)]+)\)/) || [])[1] || size.split('/')[0];
          return `<li class="vhv-finder__card">
            <a href="${p.url}${best ? '?variant=' + best.id : ''}">
              <div class="vhv-finder__img"><img src="${p.img}" alt="${String(p.alt || '').replace(/"/g, '&quot;')}" loading="lazy"></div>
              <p class="vhv-finder__title">${p.title}</p>
              <p class="vhv-finder__line">${it.line || ''}</p>
              <p class="vhv-finder__size"><span>Suggested size: ${short.trim()}</span><span>${best ? this.fmt.format(best.p / 100) : ''}</span></p>
            </a></li>`;
        }).join('');
        this.querySelector('[data-cards]').innerHTML = html;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vhv-quote"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('vhv-quote')) return;
    var KEY = 'vhv-quote-draft';
    class VhvQuote extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        var done = this.querySelector('[data-done]');
        if (done) {
          try { sessionStorage.removeItem(KEY); } catch (e) {}
          requestAnimationFrame(function () { done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true }); });
          return;
        }
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.root = this.closest('.vhv-quote');
        this.root.classList.add('vhv-quote--js');
        this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-step]'));
        this.nav = this.querySelector('[data-steps]');
        this.bar = this.querySelector('[data-bar]');
        this.nav.hidden = false; this.bar.hidden = false;
        this.$back = this.querySelector('[data-back]');
        this.$next = this.querySelector('[data-next]');
        this.$send = this.querySelector('[data-send]');
        this.at = 0; this.reached = 0;
        this.restore();
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.save.bind(this));
        this.addEventListener('input', this.onInput.bind(this));
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.form.addEventListener('keydown', this.onKey.bind(this));
        var hasErr = this.querySelector('[role=alert]');
        this.go(hasErr ? 3 : 0, true);
      }
      vals(sel) { return Array.prototype.slice.call(this.querySelectorAll(sel + ':checked')).map(function (i) { return i.value; }); }
      sync() {
        this.querySelector('[data-out=kind]').value = this.vals('[data-kind]').join(', ');
        this.querySelector('[data-out=use]').value = this.vals('[data-use]').join(', ');
      }
      valid(i, show) {
        var ok = true;
        if (i === 0) ok = this.vals('[data-kind]').length > 0;
        if (i === 2) {
          var self = this;
          ['contact[name]', 'contact[email]'].forEach(function (n) {
            var f = self.form.elements[n];
            var good = f.value.trim() !== '' && f.checkValidity();
            if (show) f.setAttribute('aria-invalid', good ? 'false' : 'true');
            if (!good) ok = false;
          });
        }
        var e = this.querySelector('[data-err="' + i + '"]');
        if (e && show) e.hidden = ok;
        return ok;
      }
      go(i, quiet) {
        i = Math.max(0, Math.min(this.steps.length - 1, i));
        if (i > this.at) { for (var s = this.at; s < i; s++) { if (!this.valid(s, true)) { i = s; break; } } }
        this.at = i; this.reached = Math.max(this.reached, i);
        var self = this;
        this.steps.forEach(function (el, n) {
          el.classList.toggle('is-current', n === i);
          el.classList.toggle('is-past', n < i);
          el.inert = n !== i;
        });
        Array.prototype.slice.call(this.nav.children).forEach(function (li, n) {
          li.classList.toggle('is-current', n === i);
          li.classList.toggle('is-done', n < i);
          li.classList.toggle('is-locked', n > self.reached);
          var b = li.querySelector('button');
          if (n === i) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
        });
        this.bar.querySelector('span').style.setProperty('--p', (i + 1) / this.steps.length);
        this.$back.hidden = i === 0;
        this.$next.hidden = i === this.steps.length - 1;
        this.$send.hidden = i !== this.steps.length - 1;
        if (i === this.steps.length - 1) this.summary();
        if (!quiet) {
          var first = this.steps[i].querySelector('input:not([type=hidden]), textarea, button');
          var top = this.root.getBoundingClientRect().top;
          if (top < 0) this.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
        }
      }
      tx(i, fb) { var t = (this.dataset.i18n || '').split('|'); return t[i] || fb; }
      summary() {
        this.sync();
        var f = this.form.elements;
        var rows = [
          [this.tx(0, 'Shoot'), this.querySelector('[data-out=kind]').value, 0],
          [this.tx(1, 'Location'), f['contact[Location]'].value, 1],
          [this.tx(2, 'Date'), (f['contact[Preferred date]'].value || '') + (f['contact[Date is flexible]'].checked ? (f['contact[Preferred date]'].value ? ', ' + this.tx(10, 'flexible') : this.tx(11, 'Flexible')) : ''), 1],
          [this.tx(3, 'Used for'), this.querySelector('[data-out=use]').value, 1],
          [this.tx(4, 'Budget'), (this.querySelector('input[name="contact[Budget]"]:checked') || {}).value || '', 1],
          [this.tx(5, 'Name'), f['contact[name]'].value, 2],
          [this.tx(6, 'Company'), f['contact[Company]'].value, 2],
          [this.tx(7, 'Email'), f['contact[email]'].value, 2],
          [this.tx(8, 'Phone'), f['contact[phone]'].value, 2],
          [this.tx(9, 'Message'), f['contact[body]'].value, 2]
        ];
        var dl = this.querySelector('[data-summary]');
        dl.textContent = '';
        var chg = this.tx(12, 'Change');
        rows.forEach(function (r) {
          if (!String(r[1]).trim()) return;
          var d = document.createElement('div');
          var dt = document.createElement('dt'); dt.textContent = r[0];
          var dd = document.createElement('dd'); dd.textContent = r[1];
          var b = document.createElement('button'); b.type = 'button'; b.textContent = chg; b.dataset.goto = r[2];
          b.setAttribute('aria-label', chg + ' ' + r[0].toLowerCase());
          d.append(dt, dd, b); dl.appendChild(d);
        });
      }
      onClick(e) {
        var t = e.target;
        if (t.closest('[data-next]')) { this.go(this.at + 1); return; }
        if (t.closest('[data-back]')) { this.go(this.at - 1); return; }
        var g = t.closest('[data-goto]');
        if (g) { var n = Number(g.dataset.goto); if (n <= this.reached || n < this.at) this.go(n); }
      }
      onInput(e) {
        if (e.target.getAttribute('aria-invalid') === 'true' && e.target.checkValidity() && e.target.value.trim()) e.target.setAttribute('aria-invalid', 'false');
        clearTimeout(this._st); this._st = setTimeout(this.save.bind(this), 300);
      }
      onKey(e) {
        if (e.key === 'Enter' && e.target.tagName === 'INPUT' && this.at < this.steps.length - 1) { e.preventDefault(); this.go(this.at + 1); }
      }
      onSubmit(e) {
        this.sync();
        for (var s = 0; s < this.steps.length - 1; s++) {
          if (!this.valid(s, true)) { e.preventDefault(); this.go(s); return; }
        }
        this.$send.disabled = true;
        this.$send.textContent = this.tx(13, 'Sending');
      }
      save() {
        this.sync();
        var data = {};
        Array.prototype.forEach.call(this.form.querySelectorAll('input, textarea'), function (f, i) {
          if (f.type === 'hidden') return;
          data[i] = (f.type === 'checkbox' || f.type === 'radio') ? f.checked : f.value;
        });
        try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
      }
      restore() {
        var data;
        try { data = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
        if (!data) return;
        Array.prototype.forEach.call(this.form.querySelectorAll('input, textarea'), function (f, i) {
          if (f.type === 'hidden' || !(i in data)) return;
          if (f.type === 'checkbox' || f.type === 'radio') f.checked = !!data[i]; else f.value = data[i];
        });
        this.sync();
      }
    }
    customElements.define('vhv-quote', VhvQuote);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vhv-specs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vhv-tabs')) {
    customElements.define('vhv-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
              e.preventDefault();
              const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
              this.select(n); this.tabs[n].focus();
            }
          });
        });
      }
      select(i) {
        this.tabs.forEach((t, j) => {
          t.setAttribute('aria-selected', String(i === j));
          const p = this.querySelector('#' + t.getAttribute('aria-controls'));
          if (p) p.hidden = i !== j;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vhv-wall-preview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vhv-wall')) {
    customElements.define('vhv-wall', class extends HTMLElement {
      connectedCallback() {
        try { this.items = JSON.parse(this.querySelector('[data-vhv-wall-data]').textContent || '[]'); } catch (e) { this.items = []; }
        this.items = this.items.filter(Boolean);
        if (!this.items.length) return;
        this.$ = (s) => this.querySelector('[data-slot="' + s + '"]');
        this.fmt = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.state = { p: 0, size: null, frame: null };
        if (this.items.length > 1) {
          this.querySelector('[data-group="product"]').hidden = false;
          this.$('products').innerHTML = this.items.map((it, i) => `<button type="button" class="vhv-wall__thumb${i === 0 ? ' is-active' : ''}" data-i="${i}" aria-label="${it.title}"><img src="${it.thumb}" alt="" loading="lazy"></button>`).join('');
          this.$('products').addEventListener('click', (e) => { const b = e.target.closest('[data-i]'); if (b) this.pick(+b.dataset.i); });
        }
        this.querySelector('[data-slot="walls"]').addEventListener('click', (e) => {
          const b = e.target.closest('[data-wall]'); if (!b) return;
          this.querySelectorAll('[data-wall]').forEach((x) => x.classList.toggle('is-active', x === b));
          this.$('stage').style.setProperty('--wall', b.dataset.wall);
          this.$('stage').classList.toggle('is-dark', b.dataset.wall === '#3b3d3f');
        });
        this.ro = new ResizeObserver(() => this.draw());
        this.ro.observe(this.$('stage'));
        this.pick(0);
      }
      disconnectedCallback() { this.ro && this.ro.disconnect(); }
      idx(it, re) { return it.options.findIndex((n) => re.test(n)); }
      pick(i) {
        this.state.p = i;
        const it = this.items[i];
        this.querySelectorAll('.vhv-wall__thumb').forEach((b, j) => b.classList.toggle('is-active', j === i));
        this.si = this.idx(it, /size|format|maat/i);
        this.fi = this.idx(it, /frame|lijst/i);
        this.bi = this.idx(it, /passe|border/i);
        const uniq = (k) => [...new Set(it.variants.map((v) => v.o[k]))];
        this.sizes = this.si > -1 ? uniq(this.si).map((label) => ({ label, cm: this.parse(label) })).filter((s) => s.cm) : [];
        this.sizes.sort((a, b) => a.cm[0] * a.cm[1] - b.cm[0] * b.cm[1]);
        this.frames = this.fi > -1 ? uniq(this.fi) : [];
        this.noBorder = this.bi > -1 ? uniq(this.bi)[0] : null;
        const mid = this.sizes[Math.min(2, this.sizes.length - 1)];
        this.state.size = mid ? mid.label : null;
        this.state.frame = this.frames.find((f) => /black/i.test(f)) || this.frames[0] || null;
        this.$('sizes').innerHTML = this.sizes.map((s) => `<button type="button" class="vhv-chip" data-size="${s.label}">${this.short(s.label)}</button>`).join('');
        this.$('frames').innerHTML = this.frames.map((f) => `<button type="button" class="vhv-chip" data-frame="${f}"><span class="vhv-chip__sw" style="--f:${this.frameColor(f)}"></span>${f.replace(/ wood/i, '')}</button>`).join('');
        this.querySelector('[data-group="frame"]').hidden = !this.frames.length;
        this.$('sizes').onclick = (e) => { const b = e.target.closest('[data-size]'); if (b) { this.state.size = b.dataset.size; this.draw(); } };
        this.$('frames').onclick = (e) => { const b = e.target.closest('[data-frame]'); if (b) { this.state.frame = b.dataset.frame; this.draw(); } };
        this.$('img').src = it.img;
        this.$('img').alt = it.title;
        this.$('link').href = it.url;
        this.draw();
      }
      parse(label) {
        const m = label.match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)\s*cm/i);
        return m ? [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))] : null;
      }
      short(label) { const m = label.match(/\(([^)]+)\)/); const cm = this.parse(label); return (m ? m[1] + ' · ' : '') + (cm ? cm[0] + '×' + cm[1] : label); }
      frameColor(f) { if (/black/i.test(f)) return '#1c1c1c'; if (/grey|gray/i.test(f)) return '#8c8378'; if (/white/i.test(f)) return '#f4f2ee'; return 'transparent'; }
      variant() {
        const it = this.items[this.state.p];
        return it.variants.find((v) => (this.si < 0 || v.o[this.si] === this.state.size) && (this.fi < 0 || v.o[this.fi] === this.state.frame) && (this.bi < 0 || v.o[this.bi] === this.noBorder))
          || it.variants.find((v) => this.si < 0 || v.o[this.si] === this.state.size);
      }
      draw() {
        const stage = this.$('stage'); if (!stage || !this.sizes) return;
        this.querySelectorAll('[data-size]').forEach((b) => b.classList.toggle('is-active', b.dataset.size === this.state.size));
        this.querySelectorAll('[data-frame]').forEach((b) => b.classList.toggle('is-active', b.dataset.frame === this.state.frame));
        const s = this.sizes.find((x) => x.label === this.state.size);
        const W = stage.clientWidth; const pxcm = W / 320;
        const print = this.$('print');
        if (s) {
          const [w, h] = s.cm;
          const prof = Math.max(w, h) > 70 ? 2 : 1.5;
          const framed = this.state.frame && !/no/i.test(this.state.frame);
          const fw = framed ? Math.max(2, prof * pxcm) : 0;
          print.style.width = (w * pxcm + fw * 2) + 'px';
          print.style.height = (h * pxcm + fw * 2) + 'px';
          print.style.borderWidth = fw + 'px';
          print.style.borderColor = framed ? this.frameColor(this.state.frame) : 'transparent';
          print.classList.toggle('is-unframed', !framed);
          this.$('dims').textContent = w + ' × ' + h + ' cm';
          this.$('scale').textContent = 'Sofa 210 cm · print ' + w + ' × ' + h + ' cm';
        }
        const v = this.variant();
        if (v) {
          this.$('variant').value = v.id;
          this.$('price').textContent = this.fmt.format(v.p / 100);
          this.$('variant-title').textContent = v.o.filter((x) => x !== this.noBorder).join(' · ');
          this.$('add').disabled = !v.a;
          this.$('link').href = this.items[this.state.p].url + '?variant=' + v.id;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vhv-work"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (!root || root.dataset.vhvReady) return;
      root.dataset.vhvReady = '1';
      var box = root.querySelector('.vhv-work__box');
      var img = box.querySelector('img');
      var cap = box.querySelector('figcaption');
      var list = [], at = 0;
      function show(i) {
        at = (i + list.length) % list.length;
        img.src = list[at].dataset.full;
        img.alt = list[at].dataset.alt;
        cap.textContent = list[at].dataset.caption + ', ' + (at + 1) + ' of ' + list.length;
      }
      root.addEventListener('click', function (e) {
        var shot = e.target.closest('.vhv-work__shot');
        if (shot) {
          list = Array.prototype.slice.call(shot.closest('.vhv-work__case').querySelectorAll('.vhv-work__shot'));
          show(list.indexOf(shot));
          if (box.showModal) box.showModal(); else box.setAttribute('open', '');
          return;
        }
        var nav = e.target.closest('.vhv-work__nav');
        if (nav) { show(at + Number(nav.dataset.step)); return; }
        if (e.target.closest('.vhv-work__close') || e.target === box) box.close();
      });
      box.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') show(at + 1);
        if (e.key === 'ArrowLeft') show(at - 1);
      });
      var x0 = null;
      box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(at + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }
    function init() { document.querySelectorAll('[data-vhv-work]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
